<template>
  <v-dialog
    content-class="custom-dialog"
    v-model="open"
    persistent
    :max-width="maxWidth"
    :scrollable="enableScroll"
    :eager="eager"
  >
    <v-card>
      <v-toolbar
        v-if="!hideToolBar"
        :color="isError ? 'error' : 'primary'"
        height="50px"
        class="custom-dialog-toolbar px-3"
      >
        <v-toolbar-title class="white--text toolbar-title" v-if="$validate.DataValid(title)">
          <v-icon v-if="isError" class="mr-1 my-1" size="20" color="colorWhite">
            {{ icon.mdiAlertCircleOutline }}
          </v-icon>
          {{ $t(title) }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="enableClose" icon color="white" small class="mr-2" @click.prevent="_dialogAction(null)">
          <v-icon class="fi fi-rr-cross-small"></v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text :class="cardContentClass" class="colorBlack--text">
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="!hideAction" class="mt-6" :class="`justify-${btnAlign}`">
        <FormButton
          v-if="enableConfirm"
          :text="confirmBtnText"
          @click="_dialogAction(true)"
          :loading="loading"
          :disabled="!enableAction"
        />
        <FormButton
          v-if="enableCancel"
          :text="cancelBtnText"
          :color="isCancelDelete ? 'error' : 'darken-1'"
          @click="_dialogAction(false)"
          :loading="loading"
          :disabled="!enableAction"
          outlined
        />
        <slot name="action"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js'
export default {
  name: 'DialogLayout',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    maxWidth: {
      default: 910,
      required: false,
    },
    hideToolBar: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    enableScroll: {
      type: Boolean,
      required: false,
      default: true,
    },
    enableCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableConfirm: {
      type: Boolean,
      required: false,
      default: true,
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: 'confirm',
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: 'cancel',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableAction: {
      type: Boolean,
      required: false,
      default: true,
    },
    btnAlign: {
      type: String,
      required: false,
      default: 'start',
    },
    cardContentClass: {
      type: String,
      required: false,
      default: 'pa-3',
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    eager: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCancelDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableCloseHide: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    icon: {
      mdiAlertCircleOutline,
    },
    open: false,
    controllerName: '',
  }),
  methods: {
    show(name = '') {
      this.open = true
      if (name) {
        this.controllerName = name
        this.$XHR.restart(name)
      }
    },
    hide(abort = false) {
      this.open = false
      if (this.controllerName && abort) {
        this.$XHR.abort(this.controllerName)
        this.controllerName = ''
      }
    },
    isOpen() {
      return this.open
    },
    _dialogAction(action) {
      if (!this.disableCloseHide) {
        this.hide(action === null)
      }
      this.$emit('close', action)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .custom-dialog {
  & .custom-dialog-toolbar {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    box-shadow: none !important;

    & > .v-toolbar__content {
      padding: 0;
    }
  }
}
</style>
